
const Heading4 = ({ className = '', style = {}, ...props }) => {

    return (
        <h4 className={ className } style={style}>
            { ...props.children }
        </h4>
    )
}

export default Heading4;
